<div data-e2e="ship-loader" id="ship-loader-container">
  <div id="ship-loader-content">
    <ng-lottie id="lottie-svg" [options]="options"></ng-lottie>
    <div *ngIf="!label || label === 'LOADER_TEXT'" id="ship-loader-text">&nbsp;</div>
    <div *ngIf="label && label !== 'LOADER_TEXT'" id="ship-loader-text">{{ label }}</div>
  </div>
</div>
